import {Serializer} from '../serializer';
import {Sector} from './sector.model';
import { TranslateService } from '@ngx-translate/core';
import { inject } from '@angular/core';

export class SectorSerializer implements Serializer {

  translateService: TranslateService = inject(TranslateService)

  fromJson(json: any): Sector {
    const sector: Sector = new Sector();

    sector.id = json.id;
    sector.active = json.active;
    sector.code = json.code;
    sector.nameDE = json.nameDE;
    sector.nameFR = json.nameFR;
    sector.nameNL = json.nameNL;
    sector.nameEN = json.nameEN;
    sector.nameTranslated = this.translateService.currentLang === "fr" ? json.nameFR : this.translateService.currentLang === "nl" ? json.nameNL : json.nameEN;

    return sector;
  }

  toJson(sector: Sector): any {
    return {
      id: sector.id,
      active: sector.active,
      code: sector.code,
      nameDE: sector.nameDE,
      nameFR: sector.nameFR,
      nameNL: sector.nameNL,
      nameEN: sector.nameEN
    };
  }

}
